import { render, staticRenderFns } from "./RecepcionesActividadPantalla.vue?vue&type=template&id=0adabbb0&"
import script from "./RecepcionesActividadPantalla.vue?vue&type=script&lang=ts&"
export * from "./RecepcionesActividadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports